import React, { useMemo } from "react";
import { useListTrapSitesQuery } from "../../../actions/trapsiteInQuery";
import { useListDevicesQuery } from "../../../actions/devicesInQuery";
import { useInfiniteAlerts } from "../../../hooks/useInfiniteAlerts";
import { MaintenanceAlert } from "./MaintenanceAlert";
import "./index.css";

const Index: React.FC = () => {
  const { data: trapSitesData, isLoading: isTrapSiteLoading } =
    useListTrapSitesQuery();
  const { data: devices, isLoading: isDevicesLoading } = useListDevicesQuery();

  const {
    allAlerts,
    isLoading: isAlertsLoading,
    isFetchingMore,
    handleScroll,
  } = useInfiniteAlerts({
    types: ["maintenance"],
    pollingInterval: 60000,
  });

  const joinedAlerts = useMemo(() => {
    if (!allAlerts.length) {
      return [];
    }

    return allAlerts.map((alert) => {
      const device = devices?.items?.find(
        (d) => d.uuid === alert.context.device,
      );

      const trapSite = trapSitesData?.items?.find((t) => {
        return t._id === (alert.context?.trap_site_id || device?.trap_site_id);
      });

      return {
        ...alert,
        device_name: device?.display_name || "",
        trap_name: trapSite?.display_name || "",
      };
    });
  }, [allAlerts, devices, trapSitesData]);

  return (
    <MaintenanceAlert
      loading={isTrapSiteLoading || isDevicesLoading || isAlertsLoading}
      isFetchingMore={isFetchingMore}
      joinedAlerts={joinedAlerts}
      onScroll={handleScroll}
    />
  );
};

export default Index;
